export default __webpack_public_path__ + "static/media/tulip.7adc0d10.jpg";